import * as React from 'react';
import { Button, Col, Row, Select } from '@nackle/paper';
import { Cross } from '@nackle/icons/dist/react-es/lindua';
import { CloudUpload } from '@nackle/icons/dist/react-es/ultimate';
import { FloppyDisk } from '@nackle/icons/dist/react-es/linear';
import { ExclamationCircle } from '@nackle/icons/dist/react-es/antd-outlined';

// components
import PDFViewer from '../pdf-viewer';
// api
import { apiGetPrivacyFile } from '../api';

export default class FileItem extends React.Component {
    handleSelect = event => {
        const value = event;
        this.props.setFileLocale( this.props.file.key, value );
    };
    removeFile = () => this.props.removeFile( this.props.file.key );
    downloadPDF = async () => {
        const blob = await apiGetPrivacyFile( this.props.file.resource );
        const data = window.URL.createObjectURL( blob );
        const link = document.createElement( 'a' );
        link.href = data;
        link.download = this.props.file.name;
        link.click();
        setTimeout( () => window.URL.revokeObjectURL( data ), 100 );
    };
    render() {
        const {
            file: { locale, file, resource },
            files,
            localeOptions,
            status,
            errors,
            enableDownloadPrivacyFiles,
            deletePrivacyFiles
        } = this.props;
        const sameLocales = files && files.length && files.filter( file => file.locale === locale );
        return (
            <Row className="list-row">
                <Col span={ 2 } className="list-item">
                    <div className="list-row-text">
                        { !!resource && <FloppyDisk style={ { fontSize: '25px' } } /> }
                        { !!file && <CloudUpload style={ { fontSize: '25px' } } /> }
                    </div>
                </Col>
                <Col span={ 10 } className="list-item">
                    <div className="list-row-text">
                        <PDFViewer file={ this.props.file } />
                        { errors.fileNameError &&
                            /[^A-Za-z0-9\\-\\.\\_]/.test( this.props.file.name ) && (
                                <ExclamationCircle style={ { color: '#d32f2f', fontSize: '25px' } } />
                            ) }
                    </div>
                </Col>
                <Col span={ status === 'Saved' ? 4 : 6  } className="list-item">
                    <div className="list-row-text">
                        { status === 'Saved'
                            ? [
                                  <Select
                                      //   name="locale"
                                      value={ locale }
                                      onChange={ this.handleSelect }
                                      key="locale-select"
                                      dropdownMatchSelectWidth={ false }
                                  >
                                      <Select.Option value="">Select one...</Select.Option>
                                      { localeOptions.map( option => (
                                          <option key={ option.code_java } value={ option.code_java }>
                                              { `${ option.code_java } ${ option.label_enUS }` }
                                          </option>
                                      ) ) }
                                  </Select>,
                                  errors.noLocaleError && !locale && (
                                      <ExclamationCircle
                                          style={ { color: '#d32f2f', fontSize: '25px' } }
                                      />
                                  ),
                                  errors.sameLocaleError && sameLocales.length > 1 && (
                                      <ExclamationCircle
                                          style={ { color: '#d32f2f', fontSize: '25px' } }
                                      />
                                  )
                              ]
                            : locale }
                    </div>
                </Col>
                <Col span={ status === 'Saved' ? 4 : 6 } className="list-item">
                    <div className="list-row-text">
                        { !!resource && (
                            <Button
                                icon="download"
                                disabled={ !enableDownloadPrivacyFiles }
                                onClick={ this.downloadPDF }
                                size="small"
                            />
                        ) }
                    </div>
                </Col>
                { status === 'Saved' && (
                    <Col span={ 4 } className="list-item">
                        <span className="list-row-text">
                            <Button
                                size="small"
                                icon={ <Cross /> }
                                className="remove-file-btn"
                                disabled={ !deletePrivacyFiles }
                                id={ `remove-file-btn-${ this.props.file.key }` }
                                onClick={ this.removeFile }
                            />
                        </span>
                    </Col>
                ) }
            </Row>
        );
    }
}
